import React, { useEffect, useState } from 'react'
import FsiPickerModal from './FsiPickerModal'
import { getDetails } from '~/services/api/files'
import _ from 'lodash'
import { useTranslation } from 'react-i18next'

interface Fsi {
  id?: string | number
  name?: string
  [key: string]: any
}

interface SelectFolderFieldProps {
  value?: Fsi | null
  onSelect?: (fsi: Fsi) => void
  options?: Record<string, any>
}

function SelectFolderField({ value, onSelect, options = {} }: SelectFolderFieldProps) {
  const [isFsiPickerOpen, setIsFsiPickerOpen] = useState<boolean>(false)
  const [selectedFsi, setSelectedFsi] = useState<Fsi | null>(null)
  const { t: translate } = useTranslation()

  useEffect(() => {
    let mounted = true
    if (value && value.id) {
      if (!value.name) {
        // download detail because we don't have a 'name' field
        getDetails(Number(value.id), null, null, true).then((data) => {
          if (mounted) {
            setSelectedFsi({
              name: data.name,
              id: data.id
            })
          }
        })
      } else {
        setSelectedFsi(value)
      }
    } else {
      setSelectedFsi(null)
    }

    return () => {
      mounted = false
    }
  }, [value])

  return (
    <>
      <p
        className={'fsi-picker-input' + (selectedFsi && selectedFsi.name ? '' : ' empty')}
        onClick={() => {
          setIsFsiPickerOpen(true)
        }}
      >
        {selectedFsi?.name || translate('-SELECT_FOLDER-')}
      </p>
      {isFsiPickerOpen && (
        <FsiPickerModal
          options={{
            selector: 'folder',
            showRC: true,
            showSystem: false,
            selectedId: selectedFsi?.id || null,
            leafIds: selectedFsi && selectedFsi.id ? [selectedFsi.id] : null,
            ...options
          }}
          title={translate('SELECT_FOLDER')}
          isOpen={isFsiPickerOpen}
          onClose={() => {
            setIsFsiPickerOpen(false)
          }}
          onSelect={(fsi: Fsi) => {
            setSelectedFsi(fsi)
            setIsFsiPickerOpen(false)
            if (fsi && fsi.id) {
              _.isFunction(onSelect) && onSelect({ id: fsi.id, name: fsi.name })
            }
          }}
        />
      )}
    </>
  )
}

export default SelectFolderField
